import { authClientWeb } from "react-redux-django-auth/web";

export interface StartAssignmentPayload {
  template_repo_name?: string;
  github_username?: string;
  course_id?: number | string;
  module_id?: number | string;
  exercise_id?: number | string;
  track?: string;
}

export interface StartAssignmentResponse {
  repository_url: string;
  repository_name: string;
  codespace_url?: string | null;
  submission_id: number;
  course_id?: number | null;
  module_name?: string | null;
  is_new: boolean;
}

export interface AssignmentSubmissionData {
  id: number;
  student_email: string;
  student_name: string;
  course_title?: string;
  repository_name: string;
  repository_url: string;
  codespace_url?: string | null;
  track?: string;
  github_username?: string;
  latest_commit_sha?: string | null;
  score: number;
  passed_tests: number;
  total_tests: number;
  module_scores?: Record<string, number>;
  is_passed: boolean;
  module_name?: string | null;
  matched_key?: string | null;
  module_score?: number | null;
  module_passed?: boolean | null;
  created_at: string;
  updated_at: string;
}

export interface CodespaceDetails {
  name: string;
  state: string;
  web_url: string;
  created_at?: string;
  last_used_at?: string;
}

export interface CodespaceStatusResponse {
  submission_id?: number;
  repository_name: string;
  has_existing_codespace: boolean;
  codespace: CodespaceDetails | null;
  create_new_url: string | null;
}

export const assignmentService = {
  startAssignment: async (
    payload: StartAssignmentPayload,
    signal?: AbortSignal
  ): Promise<StartAssignmentResponse> => {
    const res = await authClientWeb().post<StartAssignmentResponse>(
      "/courses/assignments/start/",
      payload,
      { signal }
    );
    return res.data;
  },

  getSubmissions: async (
    params?: {
      course_id?: number | string;
      exercise_id?: number | string;
      module_name?: string;
    },
    signal?: AbortSignal
  ): Promise<AssignmentSubmissionData[]> => {
    const res = await authClientWeb().get<AssignmentSubmissionData[]>(
      "/courses/assignments/submissions/",
      {
        params,
        signal,
      }
    );
    return res.data;
  },

  getCodespaceStatus: async (
    submissionId: number | string,
    signal?: AbortSignal
  ): Promise<CodespaceStatusResponse> => {
    const res = await authClientWeb().get<CodespaceStatusResponse>(
      `/courses/assignments/${encodeURIComponent(String(submissionId))}/codespace-status/`,
      { signal }
    );
    return res.data;
  },
};
